export const RUNTIME_MISSING_DSS_DATA_EXCEPTION = "bbabfa51-57a3-423f-b0e6-39c9fb3c3757";
export const RUNTIME_ALGORITHM_DID_NOT_RUN = "157d7e55-a5f2-4fe5-a738-a09b6edd3155";

export const getGraphQLErrorForPathAndCode = function(
    graphQLError,
    path,
    runtimeExceptionCode
){
  if (graphQLError.graphQLErrors){
    for (let i=0; i<graphQLError.graphQLErrors.length; i++){
      const errors = graphQLError.graphQLErrors[i];
      const validation = errors?.extensions?.validation;

      if (validation && validation[path]){
         for (let j=0; j<validation[path].length; j++){
            if (validation[path][j].code === runtimeExceptionCode){
              return validation[path][j];
            }
         }
      }
    }
  }

  return null;
}

export const getGraphQLErrorForPathAndCodes = function(
    graphQLError,
    path,
    runtimeExceptionCodes
)
{
    return runtimeExceptionCodes
        .map(runtimeExceptionCode => getGraphQLErrorForPathAndCode(graphQLError, path, runtimeExceptionCode))
        .filter(error => error !== null)
}

export const isValidationError = function(graphQLError) {
  return graphQLError?.graphQLErrors?.[0]?.message === 'validation';
}